import { render, staticRenderFns } from "./investor.vue?vue&type=template&id=78423ecc&scoped=true&"
import script from "./investor.vue?vue&type=script&lang=js&"
export * from "./investor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78423ecc",
  null
  
)

export default component.exports